module.exports = __webpack_public_path__ + "static/media/azure.e5d88d45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/azure.svg
// module id = 543
// module chunks = 49